import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn,
    AbstractControl
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormInlineRowComponent } from './../forms/form-inline-row';
import { MessageComponent, BaseComponent } from '../common/common-components';
import { DictionaryService } from "../services/dictionary-service";
import { BankAccountService } from "../accounts/bank-account-service";
import { MessageService } from "../services/message-service";
import { WalletService } from "./wallet-service";
import {Subscription, timer} from 'rxjs';
import { ModalService } from "../services/modal-service";
import { UserService } from "../user/user-service";
import {IDropdownItem} from "../types/dropdown-item";
declare var ga: any;
declare var DobryKantor: any;

let _: any = require("lodash");

@Component({
    selector: 'dk-wallet-exchange',
    inputs: ['id'],
    template: require('./wallet-exchange.html'),
    providers: [DictionaryService, BankAccountService, WalletService, UserService]
})

export class WalletExchangeComponent extends BaseComponent implements OnInit {
    public id: number;
    public errorMessageId: string;
    public isExchangeModeBankAccount: boolean;
    public currencies: any[];
    public currenciesFrom: any[];
    public currenciesTo: any[];
    public bankCodes: any[];
    public exchangeModes: any[];
    public purposes: any[];
    public timeOptions: IDropdownItem[];
    public costOptions: IDropdownItem[];
    public withdrawalModes: any[];
    public resultCurrencyStateAmount: any;
    public exchangeAmount: number;
    public cantorBankCodeId: any;
    public exchangeRateId: any;
    public viewNumber: number = 1;
    public transaction: any;
    public masterCurrencySymbol: any;
    public slaveCurrencySymbol: any;
    public discount: any;
    public isActive: boolean = false;
    public rate: any;
    public subscription: Subscription;
    public isReady: boolean = false;
    public loaded: boolean = false;
    public resultMessage: any;
    public summaryDataAccount: any;
    public summaryDataCurrency: any;
    public counter: number = 0;
    public commissionAmount: number = 0;
    public showCommission: boolean = false;
    public withdrawalAmount: number = 0;
    public maxAmount: number = 0;
    public submitLock: boolean = false;
    public showCostOption = false;
    public showTimeOption = false;
    public isTransBlocked: boolean = false;
    public personalData: boolean = false;
    public isEmptyBalance: boolean = true;
    public firstExchangeUrl: string;
    public showThirdPartyTransferAccept: boolean = false;
    public isThirdParty: boolean = false;
    public purposeLimit: number = null;
    public purposePlnLimit: number = null;


    form: FormGroup = new FormGroup({
        CurrencyFromId: new FormControl(null, Validators.required),
        CurrencyToId: new FormControl(null, Validators.required),
        Amount: new FormControl(null, [Validators.required, this.checkMaxAmount()]),
        BankCodeId: new FormControl(null, Validators.required),
        TransferTitle: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(120)]),
        ExchangeModeId: new FormControl('1', Validators.required),
        WithdrawalModeId: new FormControl('1', Validators.required),
        TimeOption: new FormControl('0', Validators.required),
        CostOption: new FormControl('0', Validators.required),
        ThirdPartyTransferAccepted: new FormControl(false),
        SmsCode: new FormControl(''),
        TransferPurpose: new FormControl(''),
        TransferPurposeTxt: new FormControl('')
    });

    checkMaxAmount() {
        return (c: FormControl) => {
            if (this.form) {
                if (this.isExchangeModeAmountFromWallet) {
                    return c.value <= this.maxAmount ? null : {
                        checkMaxAmount: {
                            valid: false,
                        }
                    };
                }

                return null;
            }
        }
    }

    constructor(private dictionaryService: DictionaryService, private messageService: MessageService,
                private bankAccountService: BankAccountService, private route: ActivatedRoute,
                private walletService: WalletService, private modalService: ModalService, 
                private userService: UserService) {
        super();
    }

    public ngOnInit() {
        this.bankAccountService.isAccountActive().subscribe(result => {
            this.isActive = result;
        });

        this.userService.accountInfo().subscribe(result => {
            this.personalData = result;
        });

        this.walletService.isEmptyBalance().subscribe(result => {
            this.isEmptyBalance = result;
        });

        this.bankAccountService.isAccountReadyForExchange().subscribe(result => {
             if(result==2){
                this.isTransBlocked = true;
                this.isReady = false;
            } else {
                this.isReady = result;
            }
            this.loaded = true;
        });
        this.withdrawalModes = [];

        this.withdrawalModes.push({
            Id: "1",
            Name: "wypłać na konto"
        });

        this.withdrawalModes.push({
            Id: "2",
            Name: "umieść w portfelu"
        });

        this.exchangeModes = [];

        this.exchangeModes.push({
            Id: "1",
            Name: "wymień podaną kwotę"
        });

        this.exchangeModes.push({
            Id: "2",
            Name: "uzyskaj kwotę po wymianie"
        });

        this.timeOptions = [];

        this.timeOptions.push({
            Id: "0",
            Name: "standard"
        });

        this.timeOptions.push({
            Id: "1",
            Name: "ekspres"
        });

        this.costOptions = [];

        this.costOptions.push({
            Id: "0",
            Name: "SHA"
        });

        this.costOptions.push({
            Id: "1",
            Name: "OUR"
        });

        let amount = this.route.snapshot.params['amount'];

        if (amount) {
            this.form.controls['Amount'].setValue(amount);

            let currencyId = this.route.snapshot.params['currencyId'];

            if (currencyId) {
                this.form.controls['ExchangeModeId'].setValue('1');
            } else {
                this.form.controls['ExchangeModeId'].setValue('2');
            }
        }

        this.walletService.masterCurrencies().subscribe(result => {
            if (result.length == 0)
                return;

            this.currenciesFrom = result;
            let currencyId = this.route.snapshot.params['currencyId'];

            var currencyFrom = _.find(this.currenciesFrom, q => q.Id == currencyId);

            if (!currencyFrom) {
                currencyFrom = _.find(this.currenciesFrom, q => q.Symbol == currencyId);
            }

            if (currencyFrom) {
                this.form.controls['CurrencyFromId'].setValue(currencyFrom.Id);
            } else {
                this.form.controls['CurrencyFromId'].setValue(result[0].Id);
            }
        });

        this.form.controls['CurrencyFromId'].valueChanges.subscribe(newValue => {
            this.maxAmount = _.find(this.currenciesFrom, q => q.Id == newValue).Amount;
            this.form.controls["Amount"].updateValueAndValidity();
            this.walletService.slaveCurrencies(newValue).subscribe(result => {
                this.currenciesTo = result;

                let currencyToId = this.route.snapshot.params['currencyToId'];

                var currencyTo = _.find(this.currenciesTo, q => q.Id == currencyToId);

                if (!currencyTo) {
                    currencyTo = _.find(this.currenciesTo, q => q.Symbol == currencyToId);
                }

                if (currencyTo) {
                    this.form.controls['CurrencyToId'].setValue(currencyTo.Id);
                    this.slaveCurrencySymbol = currencyTo.Name;
                } else {
                    this.form.controls['CurrencyToId'].setValue(result[0].Id);
                    this.slaveCurrencySymbol = result[0].Name;
                }
            });
        });

        this.form.controls['CurrencyToId'].valueChanges.subscribe(newValue => {
            this.slaveCurrencySymbol = _.find(this.currenciesTo, q => q.Id == newValue).Name;
            this.bankAccountService.bankCodesForCurrency(newValue).subscribe(bankCodes => {
                this.bankCodes = bankCodes;
                this.form.controls['BankCodeId'].setValue(bankCodes[0].BankCodeID);
            })
        });

        this.form.controls['BankCodeId'].valueChanges.subscribe(bankCodeId => {
            this.loadCommission();
            this.loadOptions(bankCodeId);
            this.loadPurposeIfNeeded();
        });

        this.form.controls['TimeOption'].valueChanges.subscribe(bankCodeId => {
            this.loadCommission();
            this.loadOptions(this.form.controls['BankCodeId'].value);
        });

        this.form.controls['CostOption'].valueChanges.subscribe(bankCodeId => {
            this.loadCommission();
            this.loadOptions(this.form.controls['BankCodeId'].value);
        });

        this.form.controls['Amount'].valueChanges.subscribe(value => {
            this.loadCommission();
            this.loadPurposeIfNeeded();
        });
        
        this.form.controls['ExchangeModeId'].valueChanges.subscribe(value => {
            this.loadCommission();
            this.loadPurposeIfNeeded();
        });

        this.walletService.title(2).subscribe(result => {
            this.form.controls['TransferTitle'].setValue(result);
        });

        this.form.controls['WithdrawalModeId'].valueChanges.subscribe(() => {
            this.loadCommission();
        });

        this.dictionaryService.accountCurrencies().subscribe(currencies => {
            this.currencies = currencies;
        });

        this.firstExchangeUrl = DobryKantor.params.cantor.firstExchangeUrl;
    }

    loadOptions(bankCodeId: number) {
        let bankCode = _.find(this.bankCodes, q => q.BankCodeID == bankCodeId);
        this.showCostOption = bankCode.costopt === 1;
        this.showTimeOption = bankCode.timeopt === 1;
        this.isThirdParty = bankCode.ThirdParty === 1;
        this.showThirdPartyTransferAccept = this.isThirdParty;
    }

    loadRate() {
        this.walletService.currentRate(
            this.form.controls['Amount'].value,
            this.form.controls['ExchangeModeId'].value == '1' ? this.form.controls['CurrencyFromId'].value : this.form.controls['CurrencyToId'].value,
            this.form.controls['CurrencyFromId'].value,
            this.form.controls['CurrencyToId'].value,
            this.transaction.WithdrawalModeId == '1' ? this.transaction.BankCodeId : null,
            this.showTimeOption ? (this.form.controls['TimeOption'].value == '1' ? true : false) : false,
            this.showCostOption ? (this.form.controls['CostOption'].value == '1' ? true : false) : false,

        ).subscribe(result => {
            this.rate = result[0].ExchangeRateAmount;
            this.exchangeAmount = result[0].ExchangeAmount;
            this.exchangeRateId = result[0].ExchangeRateID;
            this.masterCurrencySymbol = result[0].MasterCurrencySymbol;
            this.slaveCurrencySymbol = result[0].SlaveCurrencySymbol;
            this.discount = Math.floor(result[0].AccountRebate);
            this.resultMessage = "Za <b>" + this.getAmount + " " + (this.form.controls['ExchangeModeId'].value == '1' ? result[0].MasterCurrencySymbol : result[0].SlaveCurrencySymbol)
                + "</b> " + (this.form.controls['ExchangeModeId'].value == '1' ? "otrzymasz łącznie" : "zapłacisz łącznie")
                + " <b>" + this.exchangeAmount.toFixed(2) + " " + (this.form.controls['ExchangeModeId'].value == '1' ? result[0].SlaveCurrencySymbol : result[0].MasterCurrencySymbol) + "</b>.";

            if(this.masterCurrencySymbol == "PLN"){
                this.resultCurrencyStateAmount = result[0].ResultCurrencyStateAmount /*- this.commissionAmount*/;
                if(this.maxAmount-(this.form.controls['ExchangeModeId'].value == '1' ? this.getAmount : this.exchangeAmount) < this.commissionAmount){
                    this.withdrawalAmount = (this.maxAmount - this.commissionAmount)/this.rate;
                } else {
                    this.withdrawalAmount = (this.form.controls['ExchangeModeId'].value == '1' ? this.exchangeAmount : this.getAmount)
                }
            } else {
                this.resultCurrencyStateAmount = result[0].ResultCurrencyStateAmount;
                if(this.maxAmount-(this.form.controls['ExchangeModeId'].value == '1' ? this.getAmount : this.exchangeAmount) < this.commissionAmount/this.rate){
                    this.withdrawalAmount = ((this.form.controls['ExchangeModeId'].value == '1' ? this.exchangeAmount : this.getAmount) - this.commissionAmount);
                } else {
                    this.withdrawalAmount = (this.form.controls['ExchangeModeId'].value == '1' ? this.exchangeAmount : this.getAmount)- this.commissionAmount
                }
            }
        });
    }

    loadCommission() {
        if (this.form.controls['WithdrawalModeId'].value == 2 || !this.form.controls['BankCodeId'].value) {
            this.showCommission = false;
            this.commissionAmount = 0;
            return;
        }

        this.bankAccountService.getMatchingCantorBankId(this.form.controls['BankCodeId'].value).subscribe(result => {
            this.cantorBankCodeId = result[0].CantorBankCodeID;
            this.walletService.loadCommission(
                this.form.controls['CurrencyFromId'].value,
                this.form.controls['CurrencyToId'].value,
                this.form.controls['ExchangeModeId'].value == '1' ? this.form.controls['CurrencyFromId'].value : this.form.controls['CurrencyToId'].value,
                this.cantorBankCodeId,
                this.form.controls['BankCodeId'].value,
                this.form.controls['Amount'].value,
                this.showTimeOption ? (this.form.controls['TimeOption'].value) : "0",
                this.showCostOption ? (this.form.controls['CostOption'].value) : "0",
                ).subscribe(result => {
                this.showCommission = result != 0;
                this.commissionAmount = result;
            });
        });
    }

    public get isExchangeModeAmountFromWallet(): boolean {
        return this.form.controls['ExchangeModeId'].value == "1";
    }

    public get isWithdrawalModeBankAccount(): boolean {
        return this.form.controls['WithdrawalModeId'].value == "1";
    }

    public get getFXCurrencySymbol(): any {
        var result = this.masterCurrencySymbol == "PLN" ? this.slaveCurrencySymbol : this.masterCurrencySymbol;
        return result;
    }

    public get getFXOperation(): any {
        var result = this.masterCurrencySymbol == "PLN" ? "kupno" : "sprzedaż";
        return result;
    }

    get targetCurrency(): string {
        var currencyFromIdControl = this.form.controls["CurrencyFromId"];
        var currencyToIdControl = this.form.controls["CurrencyToId"];

        if (currencyFromIdControl && currencyToIdControl) {
            var currencyFromSymbol = '';
            var currencyToSymbol = '';
            var currencyFromId = currencyFromIdControl.value;
            var currencyToId = currencyToIdControl.value;

            if (currencyFromId && currencyToId) {
                let currencyFrom = _.find(this.currencies, q => q.Id == currencyFromId);
                let currencyTo = _.find(this.currencies, q => q.Id == currencyToId);

                if (currencyFrom && currencyTo) {
                    currencyFromSymbol = currencyFrom.Symbol;
                    currencyToSymbol = currencyTo.Symbol;
                }
            }

            if (this.isExchangeModeAmountFromWallet) {
                return currencyFromSymbol;
            } else {
                return currencyToSymbol;
            }
        }

        return null;
    }

    public get getBaseAmount(): any {
        var result = this.getFXCurrencySymbol == "JPY" ? 100 : 1;
        return result;
    }

    public get showDiscount(): boolean {
        return this.discount > 0;
    }

    public get getAmount(): number {
        return this.form.controls['Amount'].value;
    }

    public exchangeEverything() {
        this.form.controls['Amount'].setValue(this.maxAmount);
    }

    next() {
        if (this.viewNumber != 1)
        {
            return;
        }

        this.touchFormGroup(this.form);
        if (this.form.valid) {
            this.transaction = this.form.value;
            this.summaryDataAccount = _.find(this.bankCodes, q => q.BankCodeID == this.transaction.BankCodeId);
            this.summaryDataCurrency = _.find(this.currenciesTo, q => q.Id == this.transaction.CurrencyToId);
            this.viewNumber = 2;
            let timer$ = timer(0, 1000);

            this.loadRate();
            this.counter = 20;

            this.subscription = timer$.subscribe(() => {
                if (this.counter == 0) {
                    this.counter = 20;
                    this.loadRate();
                } else {
                    this.counter--;
                }
            });
        }
    }

    back() {
        this.subscription.unsubscribe();
        this.viewNumber = 1;
    }

    confirm() {
        this.subscription.unsubscribe();
        this.touchFormGroup(this.form);

        if (this.form.valid) {
            if (this.submitLock) {
                return;
            }
            this.submitLock = true;
            this.errorMessageId = null;


            this.walletService.isSmsNeededForTransactionAction(this.transaction.BankCodeId).subscribe(isSmsNeeded => {
                if (isSmsNeeded && this.transaction.WithdrawalModeId == '1') {
                    this.modalService.sendSmsCode();
                    this.form.controls['SmsCode'].setValue('');
                    this.viewNumber = 3;
                    this.submitLock = false;
                    return;
                }
                this.bankAccountService.getMatchingCantorBankId(this.transaction.BankCodeId).subscribe(result => {
                    let item = this.getExchangeOperationItem(result);
                    this.walletService.createTransactionExchange(item).subscribe(() => {
                        this.viewNumber = 4;
                        this.submitLock = false;
                        ga('send', 'event', 'portfel', 'wymiana', `${this.getFXOperation} ${this.getFXCurrencySymbol}`, item.Amount, item);
                    }, (error) => {
                        this.submitLock = false;
                        this.errorMessageId = error.messageId;
                    });

                })
            });
        }
    }

    confirmWithSms() {
        this.touchFormGroup(this.form);
        if (this.form.valid) {
            if (this.submitLock) {
                return;
            }
            this.submitLock = true;
            this.errorMessageId = null;

            this.bankAccountService.getMatchingCantorBankId(this.transaction.BankCodeId).subscribe(result => {
                let item = this.getExchangeOperationItem(result);
                let code = this.form.controls['SmsCode'].value;
                this.walletService.createTransactionExchange(item, code).subscribe(() => {
                    this.viewNumber = 4;
                    this.submitLock = false;
                    ga('send', 'event', 'portfel', 'wymiana', `${this.getFXOperation} ${this.getFXCurrencySymbol}`, item.Amount, item);
                }, (error) => {
                    this.submitLock = false;
                    this.viewNumber = 1;
                    this.messageService.errorByMessageId(error.messageId);
                });
            });
        }
    }

    private getExchangeOperationItem(result) {
        this.cantorBankCodeId = result[0].CantorBankCodeID;
        let item = {
            CurrencyId: this.transaction.ExchangeModeId == '1' ? this.transaction.CurrencyFromId : this.transaction.CurrencyToId,
            Amount: this.transaction.Amount,
            AccountBankCodeId: this.transaction.WithdrawalModeId == '1' ? this.transaction.BankCodeId : null,
            CantorBankCodeId: this.cantorBankCodeId,
            ExchangeRateId: this.exchangeRateId,
            TransferTitle: this.form.controls['TransferTitle'].value,
            CostOpt: this.form.controls['CostOption'].value,
            TimeOpt: this.form.controls['TimeOption'].value,
            ThirdPartyTransferAccepted: this.form.controls['ThirdPartyTransferAccepted'].value,
            TransferPurpose: this.form.controls['TransferPurposeTxt'].value
        };
        return item;
    }

    
    isPurposeTxtVisible(){
        return this.isPurposeVisible() && this.purposes && this.form.controls['TransferPurpose'].value == 6;
    }
    isPurposeVisible(){
        // console.log("currency:", this.targetCurrency, "amount:", this.form.controls['Amount'].value, "limit:", (this.targetCurrency=='PLN'? this.purposePlnLimit : this.purposeLimit), "limity:" , this.purposePlnLimit , this.purposeLimit)
        return this.isThirdParty && this.form.controls['Amount'].value >= this.purposeLimit;
    }

    loadPurposeIfNeeded(){
        let currency = this.isExchangeModeAmountFromWallet? this.form.controls["CurrencyFromId"].value : this.form.controls["CurrencyToId"].value
        this.walletService.purposeLimit(currency).subscribe(value => {
            this.purposeLimit = value;
        });

        if(this.isPurposeVisible()){
            this.dictionaryService.transferPurposes().subscribe(result => {                
                this.setRequired(this.form.controls['TransferPurpose'], true);
                this.setRequired(this.form.controls['TransferPurposeTxt'], true);
                this.purposes = result;
                
                this.form.controls['TransferPurpose'].valueChanges.subscribe(purposeId => {
                    const selectedPurpose = this.purposes.find(purpose => purpose.Id == purposeId);
                    if (selectedPurpose && purposeId != 6) {
                        this.form.controls['TransferPurposeTxt'].setValue(selectedPurpose.Name);
                    } else {
                        this.form.controls['TransferPurposeTxt'].setValue('');
                    }
                });
            })
            
        } else {
            this.setRequired(this.form.controls['TransferPurpose'], false);
            this.setRequired(this.form.controls['TransferPurposeTxt'], false);
        }
    }

    setRequired(ctrl: AbstractControl, value: boolean){
        if(value){
            ctrl.setValidators(Validators.required);
        } else {
            ctrl.clearValidators();
        }
        ctrl.updateValueAndValidity();
    }
}
